var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _text, _g, _path14, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _line, _path25, _path26, _g3, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImages1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 409.599,
    height: 369.009,
    viewBox: "0 0 409.599 369.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5164c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d4595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#606162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#98999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#b4b5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#cacbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.961,
    y1: 0.938,
    x2: 0.016,
    y2: 0.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5164c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#a1a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#838486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.016,
    y1: 0.524,
    x2: 1.003,
    y2: 0.524,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.019,
    y1: 0.524,
    x2: 0.996,
    y2: 0.524,
    xlinkHref: "#linear-gradient-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Component_5_1",
    "data-name": "Component 5 \\u2013 1",
    transform: "translate(1.475)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1462.813,3233.858v320.37l-39.2-5.58-122.09-17.38-167.71-23.87-.43-122.86a77.463,77.463,0,0,0,80.07-124Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#fdece9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1465.853,3541.888c-19.88,12.59-21.59-8.01-21.59-8.01s-4.48-18.69-9.31-42.13c-33.93,8.68-89.05,13.41-89.05,13.41s-56.42-18.35-61.64-21.65c-30.59-19.29,6.684-31.16-1.886-57.17-7.18-21.81,3.286-75.19,13.166-98.54s18.094-28.187,63.92-46.876c55.838-22.771,91.44,5.852,84.24,49.932-.92,5.67-2.2,10.556-2.37,14.9-.988,24.667,21.33,18.38,22.96,41.3,1.49,20.81,32.79,40.331,30.319,87.981-.677,13.063-8.589,19.533-3.649,41.063C1492.953,3524.778,1479.323,3545.958,1465.853,3541.888Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1444.377,3367.452c-6.081,9.225-42.094-6.394-42.094-6.394l-49.906-55.808,9.87-37.979s5.1,6.3,15.806,3.557c3.9-1,8.66-4.19,14.3-7.19l.01-.01c11.54-6.14,26.75-11.47,45.78,4.41,9.71,8.11,13.2,19.36,13.57,30.94.46,14.17-3.73,28.82-6.84,38.79C1439.223,3355.888,1448.427,3361.308,1444.377,3367.452Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1352.377,3295.217s1.544-35.295,9.87-27.946c14.477,19,4.54,30.413,52.025,46.7,30.223,10.365,11.87,56.4,14.671,71.429,4.953,26.574,67.648,54.26,48.5,104.133-1.4,3.656-95.771-43.082-95.771-43.082l-25.538,5.062Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#161616",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1311.554,3469.864s-12.655-17.011-4.236-36.471c6.236-14.412,1.09-36.941,2.471-54.1,3.059-38.014,14.941-39.691,14.941-39.691l25.412,55.442s16.1,13.416,15.46,31.295S1327.083,3489.393,1311.554,3469.864Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#161616",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1365.621,3405.1l-.76,40.354s35.294-24,45.883-16.706c-9.177-21.176-12.837-43.721-15.661-55.956C1388.024,3381.03,1371.268,3405.338,1365.621,3405.1Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#fa997b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1365.433,3415.081s24.932-12.934,31.967-31.5c-13.17,10.373-31.779,23.555-31.779,23.555Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#ef5d23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M1423.843,3545.088c-.11,1.18-.18,2.36-.23,3.56l-108.644-11.314c5.46-18.77,5.982-40.465,18.282-66.641,6.079-12.939,16.008-38.382,27.42-41.271,6.973-1.764,8.731,6.045,20.012,4.8,11.576-1.282,24.274-21.8,29.744-18.847C1436.187,3429.291,1429.223,3486.418,1423.843,3545.088Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1347.96,3297.846s-9.49,20.529-16.462,23.628-18.4,14.912-16.268,35.441,13.933,50.011,37.084,52.211c23.24,2.208,41.4-16.973,54.569-39.439,10.458-19.754-4.309-44.727-17.284-49.182C1378.509,3316.7,1350.284,3308.692,1347.96,3297.846Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#fa997b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1326.927,3331.276s5.823-6.915,11.743,0",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1476.413,3558.868a73.279,73.279,0,0,1-7.336,24.208c-.01.03-31.89,17.226-38.51,15.916-2.37-.46-4.9,2.256-6.674-4.394-.62-2.31-1.21-4.85-1.78-7.58-.42-2.04-.83-4.19-1.21-6.43-.88-5.15-1.63-10.76-2.18-16.58-1.21-12.89-1.42-26.83.2-39.23.09-.68.19-1.36.3-2.03.2-1.3.43-2.58.69-3.83.75-3.65,1.69-7.11,2.58-10.39,7.53-27.66-35.1-75.07-19.96-89.59a17.877,17.877,0,0,1,3.91-2.92c4.45-2.38,8.95-1.53,14.86,1.67,5.2,2.81,11.49,7.45,19.78,13.29,25.88,18.26,27.24,26.25,33.57,43.37C1479.7,3488.018,1478.613,3526.088,1476.413,3558.868Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1434.963,3478.318c-8.12-7.16-10.94,7.49-4.94,15.96s-9.18,32.64-9.18,32.64l-1.62-4.17c.2-1.3.43-2.58.69-3.83.75-3.65,1.69-7.11,2.58-10.39,7.53-27.66-35.1-75.07-19.96-89.59a17.877,17.877,0,0,1,3.91-2.92c4.45-2.38,8.95-1.53,14.86,1.67,0,0-19.64,2.82-13.4,15.18s18.42,19.58,28.3,28.41S1443.083,3485.468,1434.963,3478.318Z",
    transform: "translate(-1086.627 -3233.858)",
    opacity: 0.5,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M1265.27,3442.443l-22.289,17.83s-1.935-.837-4.591-2.25c-5.936-3.163-15.469-9.178-14.89-15.021.844-8.447-.927-12.929,1.646-18.556,1.93-4.247-.443-6.012-3.986-9.351-3.079-2.907-13.675-9.243-13.482-14.568a3.858,3.858,0,0,1,.877-2.332c3.1-3.948,13.326,3.309,20.851,11.418s17.262,11.808,19.462,12.267,8.644,4.017,12.5,8.145A15.38,15.38,0,0,1,1265.27,3442.443Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#fa997b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1243.6,3461.08c-13.5-7.588-20.675-12.235-20.1-18.078.844-8.447-.927-12.929,1.646-18.556,1.93-4.247-.443-6.012-3.986-9.351-3.079-2.907-13.675-9.243-13.482-14.568,1.057,4.866,11.344,11.348,15.155,14.121,4.151,3.021,5.716,6.773,4.257,10.392s-1.841,10.452-1.07,16.362,16.047,15.767,16.047,15.767C1242.2,3457.7,1243.571,3460.632,1243.6,3461.08Z",
    transform: "translate(-1086.627 -3233.858)",
    opacity: 0.06
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(4.998 12.683)",
    fill: "#fdece9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(0 11.018)",
    fill: "none",
    stroke: "#ddc2bf",
    strokeMiterlimit: 10,
    strokeWidth: 2.95
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "</>",
    transform: "translate(19.863 104.743)",
    fill: "#404041",
    fontSize: 83.822,
    fontFamily: "Neon80s, 'Neon 80s'",
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&lt;/&gt;"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(-1086.627 -3233.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M1339.709,3347.706s1.023-7.607-3.833-10.266-11.188-1.149-9.481,3.574Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M1339.449,3348.635c-.935,2.808-10.405,2.9-12.808-2.572s2.484-10.2,7.014-8.818A8.778,8.778,0,0,1,1339.449,3348.635Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M1334.626,3344.373a6.165,6.165,0,0,0,.111-.686,4.1,4.1,0,0,0-.272-2.723,4.462,4.462,0,0,0-.65-1.115c-1.371-1.686-3.4-1.528-5.109-.523a3.844,3.844,0,0,0-1.776,2.836,4.408,4.408,0,0,0-.248,1.364,3.7,3.7,0,0,0,3.334,3.916A4.308,4.308,0,0,0,1334.626,3344.373Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1363.126,3347.706s-1.023-7.607,3.833-10.266,11.188-1.149,9.481,3.574Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1363.386,3348.635c.935,2.808,10.405,2.9,12.808-2.572s-2.484-10.2-7.014-8.818A8.779,8.779,0,0,0,1363.386,3348.635Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M1371.6,3345.665a6.159,6.159,0,0,0,.209-.662,4.084,4.084,0,0,0,.129-2.733,4.457,4.457,0,0,0-.48-1.2c-1.109-1.868-3.145-2.01-4.977-1.264a3.846,3.846,0,0,0-2.172,2.546,4.434,4.434,0,0,0-.445,1.313,3.7,3.7,0,0,0,2.726,4.361A4.31,4.31,0,0,0,1371.6,3345.665Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1329.2,3341.383a.824.824,0,0,1-1.648,0,1.089,1.089,0,0,1,.894-1.033C1328.9,3340.35,1329.2,3340.928,1329.2,3341.383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1366.548,3342.311a.823.823,0,1,1-1.647,0,1.089,1.089,0,0,1,.894-1.033C1366.25,3341.278,1366.548,3341.856,1366.548,3342.311Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1451.713,3298.978c-1.92-7.41-6.01-18.21-14.45-26.07-14.12-13.13-44.91-9.27-44.91-9.27l.01-.01c11.54-6.14,26.75-11.47,45.78,4.41C1447.853,3276.148,1451.343,3287.4,1451.713,3298.978Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M1363.3,3331.175s5.823-6.915,11.743,0",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1346.609,3350.521s.594,4.507-.313,6.11-3.675,2.9-2.557,6.23c1.315,3.914,5.025,2.238,5.025,2.238",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#d26665",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(-1086.627 -3233.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1361.3,3381.958s-13.57,2.11-22.67-.16c0,0,2.85-3.44,4.4-4.89l.01-.01c.19-.17.35-.31.49-.42a2.525,2.525,0,0,1,3.44.73c.45.75,3.17,1.16,4.16-.59s3.74-.63,4.45.88a10.167,10.167,0,0,0,2.91,2.63C1359.913,3381.138,1361.3,3381.958,1361.3,3381.958Z",
    fill: "#d26665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1361.3,3381.958c-1.13.59-3.11,3.09-5.37,4.92a1.132,1.132,0,0,0-.13.1,4.674,4.674,0,0,1-.4.3,7.81,7.81,0,0,1-3.11,1.54c-3.62.68-8.98-.74-10.06-2.63a26.8,26.8,0,0,0-3.6-4.39,21.409,21.409,0,0,0,2.32.41C1347.253,3383.278,1356.2,3382.518,1361.3,3381.958Z",
    fill: "#d26665"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1339.407,3381.973s1.638.184,3.658.384c2.211.219,4.88.457,6.356.494,2.824.071,8.647-.88,10.743-.878",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#bc5b5b",
    strokeMiterlimit: 10,
    strokeWidth: 0.733
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-1086.627 -3233.858)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1471.486,3578.056c-3.671,11.68-16.161,19.337-31.14,22.559-.486.1-.973.2-1.459.3-.572.124-1.154.229-1.745.334h-.019c-11.823,2.088-23.541,2.05-30.244.515-22.368-5.111-76.219-44.279-97.891-57.647s-41.142-31.75-45.328-48.216c-2.145-8.448-3.881-13.6-6.083-17.449q-.258-.442-.515-.858h-.009a22.426,22.426,0,0,0-1.745-2.46,39.4,39.4,0,0,0-6.083-5.844,45.371,45.371,0,0,1-6.589-6.122c-2.422-2.993-3.146-5.968-.21-9.01a47.144,47.144,0,0,1,4.167-3.032c.677-.381,1.354-.762,2.012-1.144,4.91-2.841,12.347-2.775,12.347-2.775a17.551,17.551,0,0,1,7.008.458c.62.172,1.24.372,1.869.61a32.71,32.71,0,0,1,10.316,6.789h.029l.01.01c.9.19,1.735.333,2.526.438,6.436.811,10.307-1.1,18.049-3.185,8.715-2.364,25.524-5.911,45.928,18.641,20.385,24.523,29.3,33.762,38.7,35.6,3.986.791,18.068,6.569,33.734,15.332,1.392.772,2.8,1.573,4.214,2.393,19.165,11.2,39.55,26.506,46.138,42.391.095.209.334.886.62,1.811l.029.086C1470.942,3571.249,1472.153,3575.94,1471.486,3578.056Z",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1471.486,3578.056c-3.671,11.68-16.161,19.337-31.14,22.559-.486.1-.973.2-1.459.3-.572.124-1.154.229-1.745.334h-.019c-11.823,2.088-23.541,2.05-30.244.515-22.368-5.111-76.219-44.279-97.891-57.647s-41.142-31.75-45.328-48.216c-2.145-8.448-3.881-13.6-6.083-17.449,4.252-4.5,10.45-2.2,10.45-2.2s20.661,19.775,30.339,37.862c13.453,25.152,63.748,45.089,87.061,41.723,13.949-2.011,31.044-2.24,40.808,1.907,5.434,2.308,7.513,6.169,3.423,11.928-1.03,1.459-8.791,10.631-6.045,15.961,4.252,8.238,17.095,5.959,26.935,2,11.613-4.662,16.657-9.563,19.47-19.317.019.048.047.114.076.181l.029.086C1470.942,3571.249,1472.153,3575.94,1471.486,3578.056Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M1257.083,3477.586h-.009a24.987,24.987,0,0,0-1.745-2.456,39.014,39.014,0,0,0-6.085-5.843c-6.375-5.159-11.709-10.032-6.8-15.132.229-.244,1.719-1.479,1.914-1.609.661-.485,15.472-10.637,16.136-11.023,4.9-2.789,12.159,1.62,19.671,13.534.905.2-.493,3.011-.95,4.468C1277.495,3463.852,1272.43,3482.11,1257.083,3477.586Z",
    fill: "#242f5b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M1308.945,3450.768s18.81-4.122,38.268,20.83,26.767,31.856,38.172,34.966a111.415,111.415,0,0,1,22.283,9.286s-16.262-5.84-22.32-6.345-24.9-11.61-41.559-36.512C1336.385,3462.225,1314.561,3449.866,1308.945,3450.768Z",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M1451.332,3309.077c-.308,12.081-9.108,27.1.381,44.5s20.429,7.439,17.751,33.943c-1.071,10.607,14.242,34.391,21.289,55.368",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1350.043,3438.258s8.055-12.534,15.122-8.926,13.83,6.7,23.064,1.81c-7.734,8.251-17.879,4.18-22.028,1.427C1361.264,3429.294,1354.121,3434.594,1350.043,3438.258Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1422.793,3494.528s-2.4-13.78-11.348-31.81c-3.779-8.3-7.995-18.167-7.995-18.167s2.751,11.96,6.192,19.2,9.89,19.941,13.151,31.147",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M1449.508,3546.248s14.987,9.5,22.053,31.677C1473.251,3563.985,1456.389,3548.4,1449.508,3546.248Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#1b2544"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M1278.554,3450.8s6.09-7.493,1.117-22.758c-1.489-4.572-7.622-17.486-3.529-37.007,3.059-14.588,8.656-31.936,10.654-38.647,6.287-21.117,7.581-22.755,12.039-31.743",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1430.794,3361.012s-9.24,18.28-.887,35.146c5.056,10.209,32.906,30.823,45.138,51.2-3.138-19.347-32.55-49.249-37.256-55.167S1430.274,3375.032,1430.794,3361.012Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M1362.7,3267.8c1.26,1.971,5.8,6.052,3.738,15.061-1.26,5.516-5.718,13.259-12.784,22.386C1371.377,3301.275,1376.848,3279.452,1362.7,3267.8Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M1355.4,3387.278a7.81,7.81,0,0,1-3.11,1.54c-3.62.68-8.98-.74-10.06-2.63a26.8,26.8,0,0,0-3.6-4.39,13.7,13.7,0,0,1,3.24,2.92c.8,1.29,3.15,2.94,6.39,3.5A10.969,10.969,0,0,0,1355.4,3387.278Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#bc5b5b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M1360.018,3381.158a14.562,14.562,0,0,1-4.615-3.552,2.54,2.54,0,0,0-2.32-1.334c-.621-.016-2.093,1.255-2.813,1.685a4.005,4.005,0,0,1-3.12-.16,6.517,6.517,0,0,0-2.077-1.389,2.726,2.726,0,0,0-2.03.49c.19-.17.35-.31.49-.42a2.525,2.525,0,0,1,3.44.73c.45.75,3.17,1.16,4.16-.59s3.74-.63,4.45.88C1355.923,3378.208,1360.028,3381.158,1360.018,3381.158Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#bc5b5b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1352.955,3345.4s-5.153-5.029-10.182,0",
    transform: "translate(-1086.627 -3233.858)",
    fill: "none",
    stroke: "#f1f1f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 18.959,
    transform: "translate(306.034 111.781)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1405.821,3346.965s2.939,1.9,4.187-2.737,7.937-7.227,11.294-3.765c3.7,3.816.021,20.346-8.975,20.544s-5.385-5.164-5.385-5.164Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#fa997b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M1412.914,3347.925c-1.352,2.179-1.433,4.582-.174,5.365s3.38-.347,4.74-2.532c1.344-2.18,1.421-4.585.166-5.364S1414.266,3345.741,1412.914,3347.925Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "#ef5d23"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(-1086.627 -3233.858)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 19.853,
    cy: 19.853,
    r: 19.853,
    transform: "translate(1302.812 3324.91)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1392.657,3344.76a19.813,19.813,0,0,1-19.85,19.86c-.65,0-1.3-.03-1.94-.09a.06.06,0,0,1-.04-.01,19.56,19.56,0,0,1-4.41-.95,20.058,20.058,0,0,1-2.73-1.18,19.849,19.849,0,0,1,9.12-37.48,19.531,19.531,0,0,1,7.51,1.48,19.771,19.771,0,0,1,7.67,5.58,20.177,20.177,0,0,1,2.2,3.2,19.574,19.574,0,0,1,2.05,5.53,18.575,18.575,0,0,1,.41,3.75C1392.657,3344.55,1392.657,3344.66,1392.657,3344.76Z",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1387.773,3332.428l-21.08,30.68a20.052,20.052,0,0,1-2.73-1.179,19.76,19.76,0,0,1-5.26-3.941l21.4-31.14A19.769,19.769,0,0,1,1387.773,3332.428Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1391.743,3340.9l-14.84,22.775a20.489,20.489,0,0,1-3.948.454c-.65,0-1.97-.09-1.98-.1l18.718-28.659a19.555,19.555,0,0,1,2.05,5.53Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1336.865,3331.916l-21.236,30.87a14.706,14.706,0,0,1-2.7-1.29,22.048,22.048,0,0,1-5-4.21l21.269-30.95A19.767,19.767,0,0,1,1336.865,3331.916Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1341.152,3339.816l-15.615,24.059a17.145,17.145,0,0,1-3.7.191c-.5,0-2.007-.2-2.017-.207l19.287-29.232a19.3,19.3,0,0,1,.94,1.94A15.976,15.976,0,0,1,1341.152,3339.816Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-11)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1365.911,3284.717c-3.737,10.183-19.442,33.725-31.652,36.515s-15.5,15.775-17.287,22.859-11.611,11.669-11.611,11.669c2.125-8.615,2.7-13.851-2.713-24.982-4.387-9.013-9.324-23.2,2.349-39.351s18.747-28.762,39.68-30.415a23.126,23.126,0,0,1,11.416,1.771C1365.274,3266.914,1368.708,3277.131,1365.911,3284.717Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1356.093,3262.783s-16.326,1.274-27.122,7.807c-4.748,2.873-8.944,7.41-12.74,12.719s-9.159,17.3-10.567,21.612-2.509,14.287,2,21.472,6.807,20.331-2.3,29.367c2.125-8.615,2.7-13.851-2.713-24.982-4.387-9.013-9.324-23.2,2.349-39.351s18.747-28.762,39.68-30.415A23.126,23.126,0,0,1,1356.093,3262.783Z",
    transform: "translate(-1086.627 -3233.858)",
    fill: "url(#linear-gradient-16)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages1);
export default __webpack_public_path__ + "static/media/images1.dc1aed8f9f0b3fb2e729270c8d99f70d.svg";
export { ForwardRef as ReactComponent };